/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React                from 'react';
import { StyledIconInline } from '../StyledIconInline';


/*********************************************************************************
 2. Component
 *********************************************************************************/

const StyledIconChartAnalytics = StyledIconInline.extend`
  height: ${props => props.height || '24px'};
  width: ${props => props.width || '24px'};
`;

export const IconChartAnalytics = (props) => (
    <StyledIconChartAnalytics {...props}>
        <svg viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
             xmlnsXlink="http://www.w3.org/1999/xlink">
            <g strokeWidth="1" fill="none" fillRule="evenodd">
                <path d="M8.4502,12.3604 L8.4502,8.3604" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M6.4502,12.3604 L6.4502,10.3604" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12.4502,12.3604 L12.4502,7.3604" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M10.4502,12.3604 L10.4502,5.3604" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M16.4932,14.6505 L22.9092,21.0665 C23.3762,21.5335 23.3762,22.2905 22.9092,22.7565 C22.4432,
                23.2235 21.6862,23.2235 21.2192,22.7565 L14.8032,16.3405"/>
                <path
                    d="M18.2617,9.3834 C18.2617,14.2024 14.3557,18.1094 9.5367,18.1094 C4.7177,18.1094 0.8107,
                    14.2024 0.8107,9.3834 C0.8107,4.5644 4.7177,0.6584 9.5367,0.6584 C14.3557,0.6584 18.2617,
                    4.5644 18.2617,9.3834 Z" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M4.3599,12.419 L14.4629,12.419" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
        </svg>
    </StyledIconChartAnalytics>
);



// WEBPACK FOOTER //
// ./src/components/atoms/IconChartAnalytics/index.js